import { Box, Grid, Container, useTheme } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

import { useNavLinks } from '@/hooks/useNavLinks.hook';

const Navigation = () => {
  const theme = useTheme();

  const { navLinks } = useNavLinks();

  return (
    <Container
      backgroundColor={theme.colors.navigation.background}
      id='navigation'
      maxW='auto'
      px='0'
      w='100%'
      zIndex='10'
    >
      <Grid
        h='48px'
        margin='0 auto'
        maxW='800px'
        templateColumns='repeat(4, 1fr)'
      >
        {navLinks.map((item, idx) => (
          <Box
            alignItems='center'
            as={Link}
            borderBottom='3px solid'
            borderColor={
              item.selected
                ? theme.colors.navigation.borderActive
                : theme.colors.navigation.border
            }
            color={theme.colors.navigation.text}
            display='flex'
            fontSize='16px'
            fontWeight='600'
            justifyContent='center'
            key={idx}
            to={item.linkData.to}
          >
            {item.label}
          </Box>
        ))}
      </Grid>
    </Container>
  );
};

export default Navigation;
